import React, { useEffect } from 'react';
import { ModalBody } from 'reactstrap';
import Rodal from '../../../components/Rodal/Rodal';
import './LoiPrepComplete.scss';

const PREPARATION_HEADER = 'LOI Preparation Complete';
const PREPARATION_TEXT =
    "The document has been prepared for signing. This tab should close automatically — if it doesn't, you can close it now and return to the dashboard.";
const EXECUTION_HEADER = 'LOI Execution Complete';
const EXECUTION_TEXT =
    "Thank you for executing the document. We are awaiting Sign Request's confirmation of the successfully executed document. This should only take a minute or so. We appreciate your patience.";

const LoiPrepComplete = () => {
    const isSignerView = window.self !== window.top;

    useEffect(() => {
        if (!isSignerView) {
            window.close();
        }
    }, [isSignerView]);

    return (
        <Rodal
            visible={true}
            showMask={false}
            width="400"
            showCloseButton={false}
            className="loi-prep-complete">
            <ModalBody>
                <h3 className="text-center">
                    {isSignerView ? EXECUTION_HEADER : PREPARATION_HEADER}
                </h3>
                <span className="text-center d-block">
                    {isSignerView ? EXECUTION_TEXT : PREPARATION_TEXT}
                </span>
            </ModalBody>
        </Rodal>
    );
};

export default LoiPrepComplete;
